var map = {
	"./get-common-props": [
		823
	],
	"./get-common-props.js": [
		823
	],
	"./get-common-props.spec": [
		59826,
		9826
	],
	"./get-common-props.spec.js": [
		59826,
		9826
	],
	"./get-current-locale": [
		81688
	],
	"./get-current-locale.js": [
		81688
	],
	"./get-current-locale.spec": [
		55393,
		5393
	],
	"./get-current-locale.spec.js": [
		55393,
		5393
	],
	"src/common/init/get-common-props": [
		823
	],
	"src/common/init/get-common-props.js": [
		823
	],
	"src/common/init/get-common-props.spec": [
		59826,
		9826
	],
	"src/common/init/get-common-props.spec.js": [
		59826,
		9826
	],
	"src/common/init/get-current-locale": [
		81688
	],
	"src/common/init/get-current-locale.js": [
		81688
	],
	"src/common/init/get-current-locale.spec": [
		55393,
		5393
	],
	"src/common/init/get-current-locale.spec.js": [
		55393,
		5393
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 38228;
module.exports = webpackAsyncContext;